import { useT } from "@/lib/i18n/use-t";
import { T } from "./use-reason-text.i18n";

/**
 * Server-provided per-item follow-up eligibility reason code (D5) → short row
 * text. Shared by the selection checklist and the entire-client summary.
 */
export function useReasonText(): (reason: string) => string {
  const t = useT(T);
  return (reason: string) => {
    if (reason === "plan_empty") return t.reasonPlanEmpty;
    if (reason === "plan_expired") return t.reasonPlanExpired;
    if (reason.startsWith("unrecognized_isin:")) {
      return t.reasonUnrecognizedIsin(reason.slice("unrecognized_isin:".length));
    }
    if (reason.startsWith("plan_duplicate_isin:")) {
      return t.reasonPlanDuplicateIsin(reason.slice("plan_duplicate_isin:".length));
    }
    if (reason.startsWith("missing_units:")) {
      return t.reasonMissingUnits(reason.slice("missing_units:".length));
    }
    return t.reasonGeneric;
  };
}
